import api from "../../../api/apibackend";
import Nprogress from "nprogress";
import Vue from "vue";
import {
	GET_CATALOGUES,
	CREATE_CATALOGUE,
	UPDATE_CATALOGUE,
	DELETE_CATALOGUE,
} from "./actions.type";
import {
	FETCH_START,
	FETCH_END,
	SET_CATALOGUES,
	SET_TOTAL_CATALOGUES,
} from "./mutations.type";
import { GET_STORE_USER_AUTH } from "../storeModule/actions.type";

const state = {
	catalogues: null,
	loadingCatalogue: false,
	totalCatalogue: 0,
};

const getters = {
	catalogues: (state) => (state.catalogues ? state.catalogues : []),
	loadingCatalogue: (state) => state.loadingCatalogue,
	totalCatalogue: (state) => state.totalCatalogue,
};

const mutations = {
	[SET_CATALOGUES](state, catalogues, totalCatalogue) {
		state.catalogues = catalogues;
		state.totalCatalogue = totalCatalogue;
	},
	[FETCH_START](state) {
		Nprogress.start();
		state.loadingCatalogue = true;
	},
	[FETCH_END](state) {
		Nprogress.done();
		state.loadingCatalogue = false;
	},
};

const actions = {
	async [GET_CATALOGUES]({ dispatch, commit, rootGetters }) {
		try {
			commit(FETCH_START);
			if (!rootGetters.store) {
				dispatch(GET_STORE_USER_AUTH);
			}
			const res = await api.get(`store/${rootGetters.store.id}/catalogues`);
			commit(SET_CATALOGUES, res.data);
			commit(FETCH_END);
			return res.data;
		} catch (err) {
			commit(FETCH_END);
			const message = err.response.data.message;
			Vue.notify({
				group: "loggedIn",
				type: "error",
				text: message || err.message,
			});
		}
	},
	async [CREATE_CATALOGUE]({ dispatch, commit, rootGetters }, catalogue) {
		try {
			commit(FETCH_START);
			const res = await api.post(
				`store/${rootGetters.store.id}/catalogues`,
				catalogue
			);
			await dispatch(GET_CATALOGUES);
			commit(FETCH_END);
			Vue.notify({
				group: "loggedIn",
				type: "success",
				text: "✔️ Catálogo creado exitosamente",
			});
		} catch (err) {
			commit(FETCH_END);
			const message = err.response.data.message;
			Vue.notify({
				group: "loggedIn",
				type: "error",
				text: message || "❌ Ha ocurrido un error al crear el catálogo",
			});
		}
	},
	async [UPDATE_CATALOGUE]({ dispatch, commit }, catalogue) {
		try {
			commit(FETCH_START);
			await api.patch(`catalogues/${catalogue.id}`, catalogue);
			await dispatch(GET_CATALOGUES);
			commit(FETCH_END);
			Vue.notify({
				group: "loggedIn",
				type: "success",
				text: "✔️ Catálogo actualizado exitosamente",
			});
		} catch (err) {
			commit(FETCH_END);
			const message = err.response.data.message;
			Vue.notify({
				group: "loggedIn",
				type: "error",
				text: message || "❌ Ha ocurrido un error al actualizar el catálogo",
			});
		}
	},
	async [DELETE_CATALOGUE]({ dispatch, commit }, catalogueId) {
		try {
			commit(FETCH_START);
			const res = await api.delete(`catalogues/${catalogueId}`);
			await dispatch(GET_CATALOGUES);
			commit(FETCH_END);
			Vue.notify({
				group: "loggedIn",
				type: "success",
				text: "✔️ Catálogo eliminado exitosamente",
			});
		} catch (err) {
			commit(FETCH_END);
			const message = err.response.data.message;
			Vue.notify({
				group: "loggedIn",
				type: "error",
				text: message || "❌ Ha ocurrido un error al eliminar el catálogo",
			});
		}
	},
};

export default {
	state,
	getters,
	mutations,
	actions,
};
